// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/filter-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/back-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23db0b27%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-filters-navbar {
  overflow-y: scroll;
}

nav.estadisticas-filtros {
  background-color: transparent;
  display: contents;
}

nav.estadisticas-filtros button {
  float: right;
}

nav.estadisticas-filtros button .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

#offcanvasNavbarestadisticas {
  margin-top: 15vh;
  width: 101vw;
}

#offcanvasNavbarestadisticas ~ .offcanvas-backdrop {
  display: none;
}

.offcanvas-backdrop.show {
  display: none;
}

#offcanvasNavbarestadisticas .offcanvas-header {
  align-items: baseline;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

#offcanvasNavbarestadisticas .offcanvas-header h1 {
  font-weight: 700;
}

#offcanvasNavbarestadisticas .offcanvas-header button {
  margin-right: 0.6em;
}

#offcanvasNavbarestadisticas .offcanvas-header button.btn-close {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/1em
    auto no-repeat;
  opacity: 1;
}

span.estadisticas-filtros-title {
  color: #a098ae;
  font-weight: 600;
  margin-bottom: 2vh;
}

.estadisticas-filtros-group {
  flex-direction: column;
}

.estadisticas-filtros-group span.estadisticas-filtros-title {
  color: #a098ae;
  margin-top: 2vh;
}

.estadisticas-filtros-group
  span.estadisticas-filtros-title
  form.estadisticas-filtros-form
  label {
  color: #c4c4c4;
  font-size: 2.7vh;
  font-weight: 600;
}

.estadisticas-filtros-group-btn button {
  width: 100%;
}

form.estadisticas-filtros-form .form-check-input ~ label {
  color: #c4c4c4;
  font-weight: 600;
  vertical-align: sub;
}

form.estadisticas-filtros-form .form-check-input:checked ~ label {
  color: #2b363b;
}

.stats-filters-navbar form .form-check-input[type="radio"] {
  border-radius: 50%;
  font-size: 1.3em;
  height: 1em;
  width: 1em;
}

.stats-filters-navbar form input[type="radio"]:checked:after,
.stats-filters-navbar form .form-check-input:checked[type="radio"] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  content: none !important;
}

/* .stats-filters-navbar form input[type="radio"]:checked:after{
  color: green;
} */

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .stats-select-filters {
    text-align: right;
  }

  .btn-stats-secondary ~ .dropdown-menu {
    border-radius: 0 0 2vh 2vh;
    max-height: 180px;
    max-width: 40%;
    overflow-x: hidden;
    scrollbar-width: thin; /* "auto" or "thin" */
    scrollbar-color: #c4c4c4 transparent;
    width: 40%;
  }

  .btn-stats-secondary ~ .dropdown-menu:last-of-type {
    background: #fff;
    max-width: 30% !important;
    width: 30% !important;
    transform: translate3d(0, 26.2px, 0px) !important;
    min-width: 100%;
    overflow: auto;
  }

  .btn-stats-secondary ~ .dropdown-menu::-webkit-scrollbar {
    width: 12px; /* width of the entire scrollbar */
  }

  .btn-stats-secondary ~ .dropdown-menu::-webkit-scrollbar-thumb {
    background-color: #c4c4c4; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 3px solid #fff; /* creates padding around scroll thumb */
  }

  .btn-stats-secondary ~ .dropdown-menu .save-filters {
    box-shadow: 0px -2px 9px -5px rgb(0 0 0 / 60%);
  }

  .btn-stats-secondary ~ .dropdown-menu .save-filters button {
    color: #db0b27;
    font-size: 0.7rem;
    font-weight: 600;
    margin-bottom: -0.5rem !important;
    text-transform: uppercase;
  }

  .btn-stats-secondary ~ .dropdown-menu .save-filters button:hover {
    background-color: #fdf4f4;
  }

  .stats-form-checkbox {
    padding: 0.25em 2.5em;
  }

  .stats-form-checkbox .form-check-input[type="checkbox"] {
    font-size: 17px;
    line-height: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/estadisticas/estadisticas.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oEAAqE;AACvE;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;kBACgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,yDAA0J;EAC1J,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH,0BAA0B;AAC1B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,qBAAqB,EAAE,qBAAqB;IAC5C,oCAAoC;IACpC,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,iDAAiD;IACjD,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW,EAAE,kCAAkC;EACjD;;EAEA;IACE,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,sBAAsB,EAAE,wCAAwC;EAClE;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".stats-filters-navbar {\n  overflow-y: scroll;\n}\n\nnav.estadisticas-filtros {\n  background-color: transparent;\n  display: contents;\n}\n\nnav.estadisticas-filtros button {\n  float: right;\n}\n\nnav.estadisticas-filtros button .navbar-toggler-icon {\n  background-image: url(../../assets/images/filter-icon.svg) !important;\n}\n\n#offcanvasNavbarestadisticas {\n  margin-top: 15vh;\n  width: 101vw;\n}\n\n#offcanvasNavbarestadisticas ~ .offcanvas-backdrop {\n  display: none;\n}\n\n.offcanvas-backdrop.show {\n  display: none;\n}\n\n#offcanvasNavbarestadisticas .offcanvas-header {\n  align-items: baseline;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n}\n\n#offcanvasNavbarestadisticas .offcanvas-header h1 {\n  font-weight: 700;\n}\n\n#offcanvasNavbarestadisticas .offcanvas-header button {\n  margin-right: 0.6em;\n}\n\n#offcanvasNavbarestadisticas .offcanvas-header button.btn-close {\n  background: transparent url(\"../../assets/images/back-icon.svg\") center/1em\n    auto no-repeat;\n  opacity: 1;\n}\n\nspan.estadisticas-filtros-title {\n  color: #a098ae;\n  font-weight: 600;\n  margin-bottom: 2vh;\n}\n\n.estadisticas-filtros-group {\n  flex-direction: column;\n}\n\n.estadisticas-filtros-group span.estadisticas-filtros-title {\n  color: #a098ae;\n  margin-top: 2vh;\n}\n\n.estadisticas-filtros-group\n  span.estadisticas-filtros-title\n  form.estadisticas-filtros-form\n  label {\n  color: #c4c4c4;\n  font-size: 2.7vh;\n  font-weight: 600;\n}\n\n.estadisticas-filtros-group-btn button {\n  width: 100%;\n}\n\nform.estadisticas-filtros-form .form-check-input ~ label {\n  color: #c4c4c4;\n  font-weight: 600;\n  vertical-align: sub;\n}\n\nform.estadisticas-filtros-form .form-check-input:checked ~ label {\n  color: #2b363b;\n}\n\n.stats-filters-navbar form .form-check-input[type=\"radio\"] {\n  border-radius: 50%;\n  font-size: 1.3em;\n  height: 1em;\n  width: 1em;\n}\n\n.stats-filters-navbar form input[type=\"radio\"]:checked:after,\n.stats-filters-navbar form .form-check-input:checked[type=\"radio\"] {\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23db0b27'/%3e%3c/svg%3e\");\n  content: none !important;\n}\n\n/* .stats-filters-navbar form input[type=\"radio\"]:checked:after{\n  color: green;\n} */\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  .stats-select-filters {\n    text-align: right;\n  }\n\n  .btn-stats-secondary ~ .dropdown-menu {\n    border-radius: 0 0 2vh 2vh;\n    max-height: 180px;\n    max-width: 40%;\n    overflow-x: hidden;\n    scrollbar-width: thin; /* \"auto\" or \"thin\" */\n    scrollbar-color: #c4c4c4 transparent;\n    width: 40%;\n  }\n\n  .btn-stats-secondary ~ .dropdown-menu:last-of-type {\n    background: #fff;\n    max-width: 30% !important;\n    width: 30% !important;\n    transform: translate3d(0, 26.2px, 0px) !important;\n    min-width: 100%;\n    overflow: auto;\n  }\n\n  .btn-stats-secondary ~ .dropdown-menu::-webkit-scrollbar {\n    width: 12px; /* width of the entire scrollbar */\n  }\n\n  .btn-stats-secondary ~ .dropdown-menu::-webkit-scrollbar-thumb {\n    background-color: #c4c4c4; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 3px solid #fff; /* creates padding around scroll thumb */\n  }\n\n  .btn-stats-secondary ~ .dropdown-menu .save-filters {\n    box-shadow: 0px -2px 9px -5px rgb(0 0 0 / 60%);\n  }\n\n  .btn-stats-secondary ~ .dropdown-menu .save-filters button {\n    color: #db0b27;\n    font-size: 0.7rem;\n    font-weight: 600;\n    margin-bottom: -0.5rem !important;\n    text-transform: uppercase;\n  }\n\n  .btn-stats-secondary ~ .dropdown-menu .save-filters button:hover {\n    background-color: #fdf4f4;\n  }\n\n  .stats-form-checkbox {\n    padding: 0.25em 2.5em;\n  }\n\n  .stats-form-checkbox .form-check-input[type=\"checkbox\"] {\n    font-size: 17px;\n    line-height: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
